"use client";

import { Suspense } from "react";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { FaroProvider } from "@/components/faro-provider";
import PageViewTracker from "@/hooks/usePageView";

// Marketing-only provider stack since the console cutover — no session
// context needed; auth lives entirely on console.snowpad.io.
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <FaroProvider>
      <TooltipProvider delayDuration={400}>
        {/* PageViewTracker reads useSearchParams (attribution) — it must stay
            inside Suspense or static prerender of blog/landing pages bails. */}
        <Suspense fallback={null}>
          <PageViewTracker />
        </Suspense>
        {children}
        <Toaster position="top-right" expand={false} richColors />
      </TooltipProvider>
    </FaroProvider>
  );
}
